// Reconstructed from production code; original paths and local names were not available.
const MEDIA_BASE_URL =
  import.meta.env.VITE_MEDIA_BASE_URL || "";
export { MEDIA_BASE_URL };
